import axios from "axios";
import Cookies from "js-cookie";

const API_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:3100";

// Get token from cookies only
const getToken = () => {
  return Cookies.get("rovionToken") || null;
};

export const getUsers = async () => {
  try {
    const response = await axios.get(`${API_URL}/api/users`);
    return response.data;
  } catch (error) {
    console.error("Kullanıcıları getirme hatası:", error);
    return [];
  }
};

export const getAllUsers = async () => {
  return getUsers();
};

export const getUser = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/api/users/${id}`);
    return response.data;
  } catch (error) {
    console.error("Kullanıcı getirme hatası:", error);
    return null;
  }
};

export const createDealerUser = async (userData, dealerId) => {
  try {
    // Create payload with base data and ensure role is dealer
    const payload = {
      name: userData.name,
      email: userData.email,
      password: userData.password,
      role: "dealer", // Always set role to dealer
      assignedType: "dealer", // Always set assignedType to dealer
      assignedId: dealerId, // Set assignedId for new format
      dealerId: dealerId, // Set dealerId for backward compatibility
    };

    const response = await axios.post(`${API_URL}/api/users`, payload, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error creating dealer user:", error);
    throw error;
  }
};

export const createCompanyUser = async (userData, companyId) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/users`,
      {
        name: userData.name,
        email: userData.email,
        password: userData.password,
        role: "company",
        assignedType: "company",
        assignedId: companyId,
      },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("Error creating company user:", error);
    throw error;
  }
};
